import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { UserButton, useAuth } from '@clerk/clerk-react'; // Import Clerk components
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

const Header: React.FC = () => {
  const { isSignedIn, isLoaded } = useAuth(); // Get auth state

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Logo and Title */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <AutoStoriesIcon sx={{ mr: 1 }} /> {/* Reduced margin */}
          <Typography
            variant="h6"
            component={RouterLink}
            to="/"
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              fontWeight: 'bold',
            }}
          >
            CoverVision
          </Typography>
        </Box>

        {/* Navigation Links */}
        <Button
          color="inherit"
          component={RouterLink}
          to="/"
        >
          Home
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/search"
          sx={{ mr: 2 }} // Add margin before UserButton
        >
          Search
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/unmatched-books"
          sx={{ mr: 2 }}
        >
          Unmatched Books
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/scan-audit"
          sx={{ mr: 2 }}
        >
          Scan Audit
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/statistics" // Add link to statistics page
          sx={{ mr: 2 }}
        >
          Statistics
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/status" // Add link to status monitor page
          sx={{ mr: 2 }}
        >
          Status
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/postage"
          sx={{ mr: 2 }}
        >
          Postage
        </Button>
        <Button
          color="inherit"
          component={RouterLink}
          to="/wholesale"
          sx={{ mr: 2 }}
        >
          Wholesale
        </Button>

        {/* Clerk User Button */}
        {isLoaded && isSignedIn && (
          <UserButton afterSignOutUrl="/sign-in" />
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
